module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-ExtraBold.1ea8e18.ttf";